import React, { useState, useEffect } from 'react';
import { Mic, MicOff, Loader2 } from 'lucide-react';
import { useSubscription } from '../../contexts/SubscriptionContext';

interface VoiceRecorderProps {
  onTranscription: (text: string) => void;
}

export function VoiceRecorder({ onTranscription }: VoiceRecorderProps) {
  const { hasFeature } = useSubscription();
  const [isRecording, setIsRecording] = useState(false);
  const [recognition, setRecognition] = useState<any>(null);
  const isPremium = hasFeature('voice_notes');

  useEffect(() => {
    // Initialize speech recognition
    if (window.webkitSpeechRecognition) {
      const SpeechRecognition = window.webkitSpeechRecognition;
      const newRecognition = new SpeechRecognition();
      newRecognition.continuous = true;
      newRecognition.interimResults = true;
      
      newRecognition.onresult = (event: any) => {
        const transcript = Array.from(event.results)
          .map((result: any) => result[0].transcript)
          .join(' ');
        
        if (event.results[event.results.length - 1].isFinal) {
          onTranscription(transcript);
        }
      };

      newRecognition.onerror = (event: any) => {
        console.error('Speech recognition error:', event.error);
        setIsRecording(false);
      };

      setRecognition(newRecognition);
    }

    return () => {
      if (recognition) {
        recognition.abort();
      }
    };
  }, []);

  const toggleRecording = () => {
    if (!isPremium) {
      return;
    }

    if (!isRecording) {
      try {
        recognition.start();
        setIsRecording(true);
      } catch (err) {
        console.error('Error starting recording:', err);
      }
    } else {
      recognition.stop();
      setIsRecording(false);
    }
  };

  if (!isPremium) {
    return null;
  }

  return (
    <button
      onClick={toggleRecording}
      className={`p-1.5 rounded-lg transition-colors ${
        isRecording ? 'bg-red-500 text-white' : 'hover:bg-black/20'
      }`}
      title={isRecording ? 'Stop Recording' : 'Start Voice Recording'}
    >
      {isRecording ? (
        <MicOff className="w-4 h-4" />
      ) : (
        <Mic className="w-4 h-4" />
      )}
    </button>
  );
}